
import React, { useState } from 'react';

// `onMove` propを新たに追加
function CategoryManager({ categories, onAdd, onDelete, onMove }) {
  const [newCategory, setNewCategory] = useState('');

  const handleAddCategory = (e) => {
    e.preventDefault();
    if (!newCategory.trim()) return;
    onAdd(newCategory);
    setNewCategory('');
  };

  const handleDeleteCategory = (id) => {
    if (window.confirm('このカテゴリを削除してもよろしいですか？関連するFAQはカテゴリ未分類になります。')) {
      onDelete(id);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <form onSubmit={handleAddCategory} className="mb-4">
        <label htmlFor="new-category" className="block text-sm font-medium text-gray-700">新しいカテゴリ</label>
        <div className="mt-1 flex rounded-md shadow-sm">
          <input 
            type="text" 
            id="new-category"
            value={newCategory}
            onChange={e => setNewCategory(e.target.value)}
            className="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-l-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300"
            placeholder="例：料金"
          />
          <button 
            type="submit"
            className="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          >
            追加
          </button>
        </div>
      </form>

      <div className="space-y-2">
        <h3 className="text-md font-medium text-gray-800">既存のカテゴリ</h3>
        {categories.length > 0 ? (
          <ul className="divide-y divide-gray-200">
            {/* `index` を使って各カテゴリの位置を判断 */}
            {categories.map((cat, index) => (
              <li key={cat.id} className="py-2 flex justify-between items-center">
                <span className="text-sm text-gray-800">{cat.name}</span>
                <div className="flex items-center">
                  {/* 上に移動するボタン */}
                  <button 
                    onClick={() => onMove(index, 'up')} 
                    disabled={index === 0} // 最初の要素では無効化
                    className="text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed p-1"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l5 5a1 1 0 01-1.414 1.414L11 6.414V16a1 1 0 11-2 0V6.414L5.707 9.707a1 1 0 01-1.414-1.414l5-5A1 1 0 0110 3z" clipRule="evenodd" /></svg>
                  </button>
                  {/* 下に移動するボタン */}
                  <button 
                    onClick={() => onMove(index, 'down')} 
                    disabled={index === categories.length - 1} // 最後の要素では無効化
                    className="text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed p-1"
                  >
                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 17a1 1 0 01-.707-.293l-5-5a1 1 0 011.414-1.414L9 13.586V4a1 1 0 112 0v9.586l3.293-3.293a1 1 0 011.414 1.414l-5 5A1 1 0 0110 17z" clipRule="evenodd" /></svg>
                  </button>
                  <button 
                    onClick={() => handleDeleteCategory(cat.id)} 
                    className="text-red-500 hover:text-red-700 text-sm font-semibold ml-2 p-1"
                  >
                    削除
                  </button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-gray-500">まだカテゴリはありません。</p>
        )}
      </div>
    </div>
  );
}

export default CategoryManager;
